// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_lp-0";
export var fileCarousel = "_lp-2";
export var removeFileButton = "_lp-1";